var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-logo"},[_c('OIcon',{attrs:{"icon":"o-logo","aria-hidden":"true","svg-class":_vm.classes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }